<app-loader />
<app-toaster />
<router-outlet />

@if(showRedirectOverlay()){
<ng-container>
  <div
    class="fixed inset-0 z-[9999] bg-rooted/60 dark:bg-stone-900/80 backdrop-blur-sm flex items-center justify-center"
  >
    <!-- Floating Orbs -->
    <div class="absolute top-20 left-20 w-32 h-32 bg-bloom/20 dark:bg-fuchsia-500/15 rounded-full blur-3xl animate-pulse"></div>
    <div class="absolute bottom-20 right-20 w-40 h-40 bg-soulfire/15 dark:bg-fuchsia-600/10 rounded-full blur-3xl animate-pulse"></div>
    
    <div
      class="bg-white/90 dark:bg-stone-800/90 backdrop-blur-xl px-8 py-6 rounded-3xl flex items-center gap-6 shadow-2xl dark:shadow-fuchsia-900/20 border border-grounded/20 dark:border-stone-700/50 relative z-10"
    >
      <!-- Sacred Spinner -->
      <div class="relative">
        <div class="w-8 h-8 rounded-full border-4 border-sacred/40 dark:border-stone-600/60 border-t-soulfire dark:border-t-fuchsia-500 animate-spin"></div>
        <div class="absolute inset-1 w-6 h-6 rounded-full border-4 border-bloom/40 dark:border-fuchsia-400/40 border-b-bloom dark:border-b-fuchsia-400 animate-spin" style="animation-direction: reverse; animation-duration: 1.5s;"></div>
        <div class="absolute inset-2 w-4 h-4 rounded-full bg-gradient-to-r from-soulfire to-bloom dark:from-fuchsia-500 dark:to-fuchsia-400 animate-pulse"></div>
      </div>
      
      <div class="text-center">
        <span class="text-lg font-semibold bg-gradient-to-r from-soulfire to-bloom dark:from-fuchsia-400 dark:to-fuchsia-300 bg-clip-text text-transparent">
          Loading...
        </span>
        <p class="text-sm text-rooted/70 dark:text-stone-300/80 mt-1">
          Please wait While your data is loading.
        </p>
      </div>
    </div>
  </div>
</ng-container>
}